<script>
import { mapState, mapGetters, mapActions } from "vuex";
import AccountSelector from "@/components/AccountSelector";
import PromocodePreview from "@/components/referral-links/PromocodePreview";
import PromocodeCard from "@/components/referral-links/PromocodeCard.vue";
import NotMetConditionsBlock from "@/components/referral-links/NotMetConditionsBlock.vue";
import MainLoader from "@/components/helpers/MainLoader.vue";
import MasterAccountRestriction from "@/components/referral-links/MasterAccountRestriction.vue";
import OfferCard from "@/components/referral-links/OfferCard.vue";

// Кастомные офферы RC PAY (Совкомбанк), которыми дистрибьютор делится с клиентами.
// Название, картинка и кешбэк подтягиваются с backend-mobile; title здесь — запасной.
const RC_PAY_OFFERS = [
  {
    id: 46878,
    title: "Совкомбанк - Дебетовая карта с кешбэком на всё",
  },
  {
    id: 46900,
    title: "Совкомбанк - Дебетовая карта с процентом на остаток",
  },
  {
    id: 46894,
    title: "Совкомбанк - Дебетовая карта с кешбэком в категориях",
  },
  {
    id: 46901,
    title: "Совкомбанк - Карта «Халва»",
  },
];

const RC_PAY_OFFER_LINK = "https://rcpay.ru/receive?offer=";

export default {
  name: "ReferralLinks",

  components: {
    OfferCard,
    MasterAccountRestriction,
    MainLoader,
    NotMetConditionsBlock,
    PromocodeCard,
    PromocodePreview,
    AccountSelector,
  },

  data() {
    return {
      isLoading: false,
      restriction: null,
      offers: RC_PAY_OFFERS.map((offer) => ({
        ...offer,
        link: `${RC_PAY_OFFER_LINK}${offer.id}`,
        imageSrc: null,
        cashback: null,
        approveDays: null,
      })),
      premiumTariffs: ["vip_d", "vip_gold_d"],
      franchiseTariff: "vip_d",
      referralLinkTariff: ["premium_d", "vip_gold_d"],
      promocodeTariff: ["premium_d", "vip_d", "vip_gold_d"],
      highLevelTariff: ["premium_d", "vip_d", "vip_gold_d"],
      tsp: ["partner", "rcpos"],
      services: [
        {
          id: "client",
          label: "RC PAY",
          link: null,
        },
        {
          id: "distributor",
          label: "RC OFFICE",
          link: null,
        },
        {
          id: "partner",
          label: "RC CITY",
          link: null,
        },
        // {
        //   id: "rcpos",
        //   label: "RC POS",
        //   link: null,
        // },
        {
          id: "samo",
          label: "САМО",
          link: null,
        },
      ],
    };
  },

  watch: {
    selectedBinaryAccount: function () {
      this.loadLinks();
    },
  },

  computed: {
    ...mapState({
      referralLinks: (state) => state.referral.referralLinks,
      selectedBinaryAccount: (state) => state.auth.selectedBinaryAccount,
      selectedPromocode: (state) => state.referral.selectedPromocode,
      user: (state) => state.auth.user,
    }),

    ...mapGetters({
      getReferralLinkByPromocode: "referral/getReferralLinkByPromocode",
    }),

    enabledServices() {
      if (this.referralLinks.length === 0) {
        return [];
      }

      let services = [...this.services];

      if (
        this.selectedBinaryAccount.tariff.code === "vip_d" &&
        this.user.latest_exam?.status !== "passed"
      ) {
        services = services.filter((service) => service.id !== "samo");
      }

      if (
        this.selectedBinaryAccount.position === "master" &&
        this.highLevelTariff.includes(this.selectedBinaryAccount.tariff.code)
      ) {
        if (this.user.latest_exam?.status !== "passed") {
          return services.filter(
            (service) => !this.tsp.includes(service.id) && !!service.link
          );
        }

        return services.filter((service) => !!service.link);
      }

      if (
        this.showMasterRestriction ||
        this.isBaseTariffAndMasterAccountSelected
      ) {
        return [];
      }

      return services.filter((service) => !!service.link);
    },

    isShowDefaultService() {
      const rcPay = this.enabledServices.find((item) => item.id === "client");
      const rcOffice = this.enabledServices.find(
        (item) => item.id === "distributor"
      );

      return !!rcPay || !!rcOffice;
    },

    /**
     * По схеме компонент показывается если у нас обучение не пройдено
     * И соответственно показываем только на одном тарифе "Франшиза - vip_d"
     *
     * Предыдущее условие было не верно так как отталкивались мы от верхнего
     * бинака с максимальным тарифом
     * @returns {boolean}
     */
    isShowNotMetConditionBlock() {
      const isShowForFranchise =
        this.franchiseTariff === this.selectedBinaryAccount.tariff.code &&
        this.user.latest_exam?.status !== "passed";

      const isShowForLowTariffs =
        !this.highLevelTariff.includes(
          this.selectedBinaryAccount.tariff.code
        ) ||
        (this.selectedBinaryAccount.tariff.code === "premium_d" &&
          this.isShowDefaultService);

      return (
        !this.isBaseTariffAndMasterAccountSelected &&
        (isShowForFranchise || isShowForLowTariffs)
      );
    },

    notFillLink() {
      return (
        (this.user.tariff.code === "premium_d" &&
          this.selectedBinaryAccount.position === "master") ||
        (this.premiumTariffs.includes(this.user.tariff.code) &&
          this.user.latest_exam?.status !== "passed" &&
          this.selectedBinaryAccount.position === "master")
      );
    },

    isBaseTariffAndMasterAccountSelected() {
      return (
        this.selectedBinaryAccount.tariff.code === "base_d" &&
        this.selectedBinaryAccount.position === "master"
      );
    },

    useFilterLinks() {
      return (
        (this.user.tariff.code === "premium_d" &&
          this.selectedBinaryAccount.position !== "master") ||
        (this.premiumTariffs.includes(this.user.tariff.code) &&
          this.user.latest_exam?.status !== "passed" &&
          this.selectedBinaryAccount.position !== "master")
      );
    },

    showPromocode() {
      return (
        !!this.enabledServices.length &&
        !this.isBaseTariffAndMasterAccountSelected
      );
    },

    showMasterRestriction() {
      return (
        this.referralLinkTariff.includes(this.user.tariff.code) &&
        this.selectedBinaryAccount.position === "master"
      );
    },

    isVisibleEmptyMessage() {
      return (
        (this.showMasterRestriction && !this.enabledServices.length) ||
        this.isBaseTariffAndMasterAccountSelected
      );
    },
  },

  methods: {
    ...mapActions({
      loadReferralLinks: "referral/loadReferralLinks",
    }),

    loadLinks() {
      this.isLoading = true;

      // Сбрасываем все ссылки перед загрузкой новых
      this.services.forEach((service) => {
        service.link = null;
      });

      this.loadReferralLinks(this.selectedBinaryAccount.id)
        .then(() => {
          if (this.referralLinks.length === 0) {
            // Если ссылок нет, оставляем все как null
            return;
          }

          if (this.useFilterLinks) {
            this.services.forEach((service) => {
              if (service.id !== "partner" && service.id !== "rcpos") {
                service.link = this.referralLinks[0].urls[service.id] ?? null;
              } else {
                service.link = null;
              }
            });
            return;
          }

          this.services.forEach((service) => {
            service.link = this.referralLinks[0].urls[service.id] ?? null;
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    /**
     * Актуальные название, картинка и кешбэк офферов с backend-mobile (RC PAY).
     * Публичный эндпоинт, без авторизации; при ошибке карточка остаётся с запасным названием.
     */
    loadOffers() {
      const baseUrl = process.env.VUE_APP_BACKEND_MOBILE_URL;

      if (!baseUrl) {
        return;
      }

      this.offers.forEach((offer) => {
        fetch(`${baseUrl}api/v2/offers/${offer.id}`, {
          headers: { Accept: "application/json" },
        })
          .then((response) => (response.ok ? response.json() : null))
          .then((json) => {
            const data = json?.data?.offer;

            if (!data) {
              return;
            }

            offer.title = data.title || offer.title;
            offer.imageSrc = data.image_src || null;
            offer.cashback = data.cashback || null;
            offer.approveDays = data.approve_days_avg || null;
          })
          .catch(() => {});
      });
    },

    // checkRestrictions(serviceId) {
    //   if (serviceId !== "partner") return false;
    //
    //   if (
    //     this.selectedBinaryAccount.tariff?.code !== "vip_d" &&
    //     this.selectedBinaryAccount.tariff?.code !== "vip_gold_d"
    //   ) {
    //     this.restriction = "tariff.vip_d.upper.required";
    //
    //     return true;
    //   }
    //
    //   if (this.user.latest_exam?.status !== "passed") {
    //     this.restriction = "exam.required";
    //
    //     return true;
    //   }
    //
    //   return false;
    // },
  },

  mounted() {
    this.loadLinks();
    this.loadOffers();
  },
};
</script>

<template>
  <div class="referral-links">
    <div class="referral-links__account account">
      <div class="account-selector-wrapper">
        <AccountSelector />
      </div>

      <div class="account__wrapper">
        <div v-if="showPromocode && !isLoading" class="account__promo-codes">
          <PromocodePreview
            v-for="referralLink in referralLinks"
            :key="referralLink.promocode"
            :promocode="referralLink.promocode"
            :referral-link="referralLink"
          />
        </div>

        <h3>
          <img src="../../assets/icons/referral_links.svg" alt="" /> Реферальные
          ссылки
        </h3>

        <MainLoader v-if="isLoading" />

        <section v-else class="referral-links__services-list">
          <MasterAccountRestriction v-if="isVisibleEmptyMessage" />

          <PromocodeCard
            v-for="service in enabledServices"
            :key="service.id"
            :service="service"
          />

          <NotMetConditionsBlock v-if="isShowNotMetConditionBlock" />

          <!-- Офферы RC PAY доступны всем, независимо от тарифа и экзамена -->
          <OfferCard
            v-for="offer in offers"
            :key="`offer-${offer.id}`"
            :offer="offer"
          />
        </section>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.referral-links {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 64px;

  &__account {
    width: 100%;
    height: 100%;
  }

  &__services-list {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;

    @media screen and (max-width: 576px) {
      margin-bottom: 32px;
    }
  }
}

.account {
  &__wrapper {
    display: flex;
    flex-direction: column;
    background-color: $background-white;
    padding: $space-xxl;

    @media screen and (max-width: 576px) {
      padding: 0;
    }

    // @media (min-width: 426px) and (max-width: 576px) {
    //   padding: $space-xl;
    // }

    // @media (max-width: 425px) {
    //   padding: $space-xl $space-l;
    // }

    // @media (max-width: 375px) {
    //   padding: $space-xl $space-m;
    // }

    h3 {
      @include text-1;
      color: $dark-primary;
      margin: $space-xl 0;

      @media screen and (max-width: 576px) {
        padding: 0 16px;
      }
    }
  }
}

@media (min-width: 1024px) {
  .referral-links {
    &__services-list {
      gap: 24px;
    }
  }
}

@media (min-width: 1440px) {
  .referral-links {
    &__services-list {
      max-width: 940px;
      grid-template-columns: 1fr 1fr;
    }
  }
}
</style>
